/** @jsxImportSource @emotion/react */

import * as React from 'react'
import { Input } from '../input/input'
import { ButtonType } from '../button/button'
import {
  ActionHandler,
  fromLeft,
  fromRight,
  horizontalPadding,
  HandlerButton,
  leftPadding,
  rightPadding,
  Wrapper,
} from './actionInput.styles'
import { SerializedStyles } from '@emotion/react'

interface ActionInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leftAction?: ActionInputButtonProps
  rightAction?: ActionInputButtonProps
}

export interface ActionInputButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: JSX.Element
}

const getPaddingModifier = (
  leftAction: ActionInputButtonProps,
  rightAction: ActionInputButtonProps
): SerializedStyles | null => {
  if (leftAction) {
    if (rightAction) {
      return horizontalPadding
    } else {
      return leftPadding
    }
  } else if (rightAction) {
    return rightPadding
  }
  return null
}

function ActionInputWithRef(
  { leftAction, rightAction, className, ...props }: ActionInputProps,
  ref: React.Ref<HTMLInputElement>
) {
  const Action = (
    { icon, ...actionProps }: ActionInputButtonProps,
    positionModifierClass?: SerializedStyles
  ) => (
    <ActionHandler css={positionModifierClass}>
      <HandlerButton buttonType={ButtonType.GHOST} {...actionProps}>
        {icon}
      </HandlerButton>
    </ActionHandler>
  )

  return (
    <Wrapper>
      {leftAction && Action(leftAction, fromLeft)}
      <Input
        ref={ref}
        css={getPaddingModifier(leftAction, rightAction)}
        {...props}
      />
      {rightAction && Action(rightAction, fromRight)}
    </Wrapper>
  )
}

export const ActionInput = React.forwardRef(ActionInputWithRef)
